import { useEffect, useState } from "react";
import API from "@/lib/api";
import { Reveal, Eyebrow } from "./Reveal";
import { useLang } from "@/lib/lang";

const initials = (name) =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

export default function Committee() {
  const [members, setMembers] = useState([]);
  const { t } = useLang();

  useEffect(() => {
    API.get("/members")
      .then(({ data }) => setMembers(data))
      .catch(() => {});
  }, []);

  const groups = [];
  members.forEach((m) => {
    const g = groups.find((x) => x.role === m.role_label);
    if (g) g.people.push(m);
    else groups.push({ role: m.role_label, people: [m] });
  });

  return (
    <section id="committee" className="py-20 sm:py-28 bg-[#1E0A0E]/40 border-y border-[#F2B134]/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <Reveal className="text-center max-w-2xl mx-auto">
          <Eyebrow>{t("com_eyebrow")}</Eyebrow>
          <h2 className="font-bengali font-extrabold text-3xl sm:text-5xl mt-4">
            {t("com_title_a")} <span className="gold-text">{t("com_title_b")}</span>
          </h2>
        </Reveal>

        <div className="mt-14 space-y-12">
          {groups.map((g, gi) => (
            <div key={g.role}>
              <Reveal delay={gi * 0.03}>
                <h3 className="font-bengali text-xl font-bold text-[#F2B134] flex items-center gap-4">
                  {g.role}
                  <span className="flex-1 hairline" />
                </h3>
              </Reveal>
              <div className="mt-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {g.people.map((m, i) => (
                  <Reveal key={m.id} delay={i * 0.04} className="h-full">
                    <div className="h-full rounded-2xl border border-[#F2B134]/18 bg-[#120507] p-5 text-center hover:border-[#F2B134]/50 hover:-translate-y-1 transition-all duration-300" data-testid={`committee-member-${m.id}`}>
                      <span className="mx-auto h-14 w-14 rounded-full grid place-items-center text-lg font-bold text-[#2A0A0E] bg-[linear-gradient(135deg,#FFE9A8,#F2B134_55%,#D99A1F)] shadow-[0_0_24px_-6px_rgba(242,177,52,0.7)]">
                        {initials(m.name)}
                      </span>
                      <p className="font-bengali font-bold mt-4">{m.name}</p>
                      <p className="text-[11px] uppercase tracking-[0.2em] text-[#D1BBA7]/70 mt-1">{m.role_label}</p>
                    </div>
                  </Reveal>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
